import { render } from "./EditEmployeeProfile.vue?vue&type=template&id=1fed883d&scoped=true"
import script from "./EditEmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EditEmployeeProfile.vue?vue&type=script&lang=js"

import "./EditEmployeeProfile.vue?vue&type=style&index=0&id=1fed883d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fed883d"]])

export default __exports__